import { render, staticRenderFns } from "./SignupStep5.vue?vue&type=template&id=4d9628f8&scoped=true"
import script from "./SignupStep5.vue?vue&type=script&lang=js"
export * from "./SignupStep5.vue?vue&type=script&lang=js"
import style0 from "./SignupStep5.vue?vue&type=style&index=0&id=4d9628f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9628f8",
  null
  
)

export default component.exports